import { getSelectedBusinessKeyFigures } from "./dataParsing";
import { toFiniteNumber } from "./kpiFormatters";
import { SCATTER_DENOMINATORS, SCATTER_METRICS } from "../scatterConfiguration";

function readBenchmark(raw) {
  const sd = toFiniteNumber(raw.metrics?.stddev);

  return {
    mean: toFiniteNumber(raw.metrics?.mean),
    sd: sd !== null && sd >= 0 ? sd : null,
    customerValue: toFiniteNumber(raw.companyValue),
    quality: raw.metrics?.quality || null,
  };
}

export function parseScatterData(data, translate) {
  const { keyFigures } = getSelectedBusinessKeyFigures(data);

  const figuresByName = new Map(keyFigures.filter(Boolean).map((figure) => [figure.keyFigure, figure]));

  const metrics = SCATTER_METRICS.map((metric) => {
    const values = {};

    SCATTER_DENOMINATORS.forEach((denominator) => {
      const raw = figuresByName.get(`${metric.figure}_${denominator.suffix}`);

      if (raw) {
        values[denominator.id] = readBenchmark(raw);
      }
    });

    return {
      id: metric.id,
      label: translate(metric.labelKey),
      level: metric.level,
      direction: metric.direction,
      allowNegativeValues: Boolean(metric.allowNegativeValues),
      allowAbove100: Boolean(metric.allowAbove100),
      values,
    };
  });

  return metrics;
}

export function hasScatterCompanyValues(metrics) {
  return metrics.some((metric) => Object.values(metric.values).some((value) => Number.isFinite(value.customerValue)));
}
